var React = require('react');

function StepForward (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M304,219.29V48a16,16,0,0,1,16-16h48a16,16,0,0,1,16,16V464a16,16,0,0,1-16,16H320a16,16,0,0,1-16-16V219.3Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64,448V64c0-27.4,31.9-41.7,52.5-24.6L304,213.66v84.69L116.5,472.59C95.9,489.69,64,475.39,64,448Z","className":"fa-primary","key":2})]);
}

StepForward.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = StepForward;

StepForward.default = StepForward;
